/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UploadSSOVideoResponse } from "../types/UploadSSOVideoResponse.ts";

export const uploadSSOVideoResponseSchema = z.object({
  blobPath: z.string().nullish(),
  url: z.string().nullish(),
}) as unknown as ToZod<UploadSSOVideoResponse>;
